import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TABLE_TICKET_NUMBER: {
        id: 'spareParts.list.table.ticketNo',
        defaultMessage: 'Ticket No.'
    },
    TABLE_CREATED_BY: {
        id: 'spareParts.list.table.createdBy',
        defaultMessage: 'Created by (IPN)'
    },
    TABLE_ORDER_CREATION_TIME: {
        id: 'spareParts.list.table.orderCreationTime',
        defaultMessage: 'Order Creation Time'
    },
    TABLE_CLIENT_ID: {
        id: 'spareParts.list.table.clientId',
        defaultMessage: 'Client ID'
    },
    TABLE_REGION: {
        id: 'spareParts.list.table.region',
        defaultMessage: 'Region'
    },
    TABLE_COUNTRY_CODE_3: {
        id: 'spareParts.list.table.countryCode3',
        defaultMessage: 'Country Code'
    },
    TABLE_DEALER_NUMBER: {
        id: 'spareParts.list.table.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    TABLE_ORDER_TYPE: {
        id: 'spareParts.list.table.orderType',
        defaultMessage: 'Order type'
    },
    REQUEST_OF_COURTESY_CAR: {
        id: 'spareParts.list.table.requestOfCourtesyCar',
        defaultMessage: 'Courtesy car Request'
    },
    TABLE_STATUS: {
        id: 'spareParts.list.table.status',
        defaultMessage: 'Status'
    },
    TABLE_TYPE_OF_CLIENT: {
        id: 'spareParts.list.table.typeOfClient',
        defaultMessage: 'Type of Client'
    },
    TABLE_SRC_TYPE: {
        id: 'spareParts.list.table.srcType',
        defaultMessage: 'SRC Type'
    },
    TABLE_SRC_N: {
        id: 'spareParts.list.table.srcN',
        defaultMessage: 'SRC N°'
    },
    TABLE_LAST_STATUS_DATE: {
        id: 'spareParts.list.table.lastStatusDate',
        defaultMessage: 'Last Status Date'
    },
    TITLE: {
        id: 'spareParts.list.title',
        defaultMessage: 'List orders'
    },
    VISIBLE_COLUMNS: {
        id: 'spareParts.list.label.visibleColumns',
        defaultMessage: 'Visible columns'
    },
    TABLE_LAST_EDITOR: {
        id: 'spareParts.list.table.lastEditor',
        defaultMessage: 'Last Editor'
    },
    TABLE_BIN: {
        id: 'spareParts.list.table.bin',
        defaultMessage: 'BIN'
    },
    TABLE_REPLACEMENT_VEHICLE: {
        id: 'spareParts.list.table.replacementVehicle',
        defaultMessage: 'Replacement Vehicle'
    },
    TABLE_INVOICE_NUMBER: {
        id: 'spareParts.list.table.invoiceNumber',
        defaultMessage: 'Invoice Number'
    },
    TABLE_PART_NO: {
        id: 'spareParts.list.table.partNo',
        defaultMessage: 'Part No'
    },
    TABLE_MANAGEMENT_GROUP: {
        id: 'spareParts.list.table.managementGroup',
        defaultMessage: 'Management Group'
    },
    TABLE_PROBLEM_TYPE: {
        id: 'spareParts.list.table.batteryProblemType',
        defaultMessage: 'Problem Type'
    },


    INTERNAL_TICKET_TITLE: { //YY
        id: 'spareParts.list.titleInternalTicket',
        defaultMessage: 'List orders - Internal Ticket'
    },
    TABLE_SOLUTION_GROUP: {
        id: 'spareParts.list.table.solutionGroup',
        defaultMessage: 'Solution Gr.'
    },
    TABLE_CUSTOMER_FOLLOW_UP: {
        id: 'spareParts.list.table.customerFollowUp',
        defaultMessage: 'Customer Follow Up'
    },
    TABLE_INTERNAL_TICKET_NUMBER: { //YY
        id: 'spareParts.internalList.table.ticketNo',
        defaultMessage: 'Internal Ticket No.'
    },
    TABLE_REQUEST_TYPE: { //YY
        id: 'spareParts.internalList.table.requestType',
        defaultMessage: 'Request Type'
    },
    TABLE_REQUEST_STATUS: { //YY
        id: 'spareParts.internalList.table.requestStatus',
        defaultMessage: 'Request Status'
    },
    TABLE_PRIORITY: { //YY
        id: 'spareParts.internalList.table.priority',
        defaultMessage: 'Priority'
    },
    TABLE_PRIORITY_TYPE: { //YY
        id: 'spareParts.internalList.table.priorityType',
        defaultMessage: 'Priority Type'
    },
    TABLE_DEALER_TICKET_NUMBER: { //YY
        id: 'spareParts.internalList.table.dealerTicketNo',
        defaultMessage: 'Dealer Ticket No.'
    },
    TABLE_DEALER_FORM_TYPE: { //YY
        id: 'spareParts.internalList.table.dealerTicketFormType',
        defaultMessage: 'Dealer Form Type'
    },
    TABLE_IT_CREATION_TIME: { //YY
        id: 'spareParts.internalList.table.itCreationDate',
        defaultMessage: 'IT Creation Date'
    },
    TABLE_IT_CREATED_BY: { //YY
        id: 'spareParts.internalList.table.itCreatedBy',
        defaultMessage: 'IT Created by (IPN)'
    },
    TABLE_SG_REQUESTOR: { //YY
        id: 'spareParts.internalList.table.sgRequestor',
        defaultMessage: 'SG Requestor'
    },
    TABLE_ASSIGNED_SOLUTION_GROUP: { //YY
        id: 'spareParts.internalList.table.assignedSolutionGroup',
        defaultMessage: 'Assigned SG'
    },
    TABLE_DEALER_CLIENT_ID: { //YY
        id: 'spareParts.internalList.table.clientId',
        defaultMessage: 'Client ID'
    },
    TABLE_DEALER_REGION: { //YY
        id: 'spareParts.internalList.table.region',
        defaultMessage: 'Region'
    },
    TABLE_IT_DEALER_NUMBER: { //YY
        id: 'spareParts.internalList.table.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    TABLE_PART_NUMBER: { //YY
        id: 'spareParts.internalList.table.partNumber',
        defaultMessage: 'Part No.'
    },
    TABLE_MANAGEMENT_GRP: { //YY
        id: 'spareParts.internalList.table.managementGrp',
        defaultMessage: 'Management Group'
    },
    TABLE_PARTNER: { //YY
        id: 'spareParts.internalList.table.partner',
        defaultMessage: 'Partner'
    },
    TABLE_PARTNER_NAME: { //YY
        id: 'spareParts.internalList.table.partnerName',
        defaultMessage: 'Partner Name'
    },
    TABLE_IT_LAST_STATUS_DATE: { //YY
        id: 'spareParts.internalList.table.lastStatusDate',
        defaultMessage: 'Last Status Date'
    },
    TABLE_IT_LAST_EDITOR: { //YY
        id: 'spareParts.internalList.table.lastEditor',
        defaultMessage: 'Last Editor'
    },
});

export default messages;
